export default function lockBody(
  lock = true,
  container = document.querySelector('#root')
) {
  if (lock) {
    const scrollTop =
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      window.pageYOffset;
    document.body.setAttribute('data-lock-scrolltop', scrollTop);

    // add locking styles to body
    document.body.style.height = '100%';
    document.body.style.width = 'calc(100% - 40px)';
    // document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';

    // add locking styles to scrollTop
    if (container) {
      /* eslint-disable no-param-reassign */
      container.style.top = scrollTop;
      container.style.height = '100%';
      container.style.width = '100%';
      container.style.overflow = 'hidden';
      container.style.position = 'relative';
      // scroll page-container to scrollTop position
      container.scrollTop = scrollTop;
      /* eslint-enable no-param-reassign */
    }

    // attempt to scroll top fixed position
    window.requestAnimationFrame(() => {
      window.scrollTo(0, scrollTop);
    });

    return false;
  }

  const scrollTop = document.body.getAttribute('data-lock-scrolltop');
  document.body.removeAttribute('data-lock-scrolltop');

  // remove locking styles from body
  document.body.style.height = '';
  document.body.style.width = '';
  //   document.body.style.overflow = '';
  document.body.style.position = '';
  // set scroll position back

  // remove locking styles from page-container
  if (container) {
    /* eslint-disable no-param-reassign */
    container.style.top = '';
    container.style.height = '';
    container.style.width = '';
    container.style.overflow = '';
    container.style.position = '';
    /* eslint-enable no-param-reassign */
  }
  window.scrollTo(0, scrollTop);

  return true;
}



// WEBPACK FOOTER //
// ./src/scripts/lib/lockBody.js